<template>
  <div class="evento-codigos-promocion-importacion">
    <b-card no-header>
      <b-row>
        <b-col>
          <b-form>
            <b-form-group
                description="Listado de códigos en formato csv">
              <b-form-file 
                v-model="file" 
                class="mt-3" 
                accept=".csv" 
                placeholder="Seleccione un archivo o arrastrelo hasta aquí">
              </b-form-file>
              <!-- <b-input-group-append 
                class="filter-search-icons" 
                @click="importarArchivo">
                <b-input-group-text>
                  <i class="fa fa-remove"></i>
                </b-input-group-text>
              </b-input-group-append> -->
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="importarCodigos">Importar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="cancelar">Cancelar</b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'

export default {
  name: 'EventosImportacionCodigos',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  props: {
    eventoId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      file: null,
    }
  },
  computed: {
  },
  created() {
  },  
  methods: {
    cancelar() {
      this.close(false);
    },
    close(actualizado) {
      this.$emit('close', actualizado);
    },
    importarCodigos() {
      if (this.file) {
        this.showSpinner();

        let params = {
          eventoId: this.eventoId,
          file: this.file
        }

        this.$store.dispatch('eventoCodigosPromocion/importarCodigosPromocion', params)
          .then( () => this.close(true) )
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      }
    },
  },
  watch: {
  }   
}
</script>

<style>

  .evento-codigos-promocion-importacion .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: 'Buscar' !important;
  }

  .evento-codigos-promocion-importacion .b-form-file {
    position: relative;
    display: inline-block;
    width: calc(100% - 50px);
  }

  .evento-codigos-promocion-importacion .filter-search-icons {
    position: relative;
    display: inline-block;
    margin-left: 5px;
    margin-top: 6px;
    /* margin-top: 16px; */
    /* width: calc(100% - 50px); */
  }
  .evento-codigos-promocion-importacion .filter-search-icons div {
    height: 34px;
  }
</style>